// @flow

import NProgress from 'nprogress/nprogress.js'
import Notifications from 'react-notification-system-redux'
import { reset } from 'redux-form'

import {
	accountSetupCreateApi,
	accountSetupFetchHistoryApi,
	accountSetupResendApi
} from '../apis/account_setup'

export function accountSetupsFetchSuccess(accountSetups: Array<Object>) {
	return {
		type: 'ACCOUNT_SETUPS_FETCH_SUCCESS',
		accountSetups
	}
}

export function accountSetupsFetchPaginationSuccess(pagination: Object) {
	return {
		type: 'ACCOUNT_SETUPS_FETCH_PAGINATION_SUCCESS',
		pagination
	}
}

export function accountSetupsAddFilterPageNumberSuccess(page: number) {
	return {
		type: 'ACCOUNT_SETUPS_ADD_FILTER_PAGE_NUMBER_SUCCESS',
		page
	}
}

export function accountSetupsAddFilterColPerPageSuccess(per_page: number) {
	return {
		type: 'ACCOUNT_SETUPS_ADD_FILTER_PER_PAGE_SUCCESS',
		per_page
	}
}

export function accountSetupsFetchData(filterData: Object) {
	return (dispatch: Function) => {
		NProgress.start()
		dispatch(accountSetupsFetchSuccess([]))
		return accountSetupFetchHistoryApi(filterData.toJS())
			.then((response) => {
				NProgress.done()
				const { current_page, last_page, total, per_page, data } = response.data.data
				dispatch(accountSetupsFetchPaginationSuccess({ current_page, last_page, total, per_page }))
				dispatch(accountSetupsFetchSuccess(data))
			})
			.catch(() => {
				NProgress.done()
				dispatch(accountSetupsFetchSuccess([]))
				dispatch(Notifications.error({
					title: 'Error',
					message: 'An error occurred when loading data',
					position: 'bl'
				}))
			})
	}
}

export function accountSetupsAddFilterPageNumber(page: number) {
	return (dispatch: Function) => {
		return new Promise((resolve) => {
			resolve(dispatch(accountSetupsAddFilterPageNumberSuccess(page)))
		})
	}
}

export function accountSetupsAddFilterColPerPage(per_page: number) {
	return (dispatch: Function) => {
		return new Promise((resolve) => {
			resolve(dispatch(accountSetupsAddFilterColPerPageSuccess(per_page)))
		})
	}
}

export function accountSetupCreate(data: Object) {
	return (dispatch: Function) => {
		NProgress.start()
		return accountSetupCreateApi(data)
			.then((response) => {
				NProgress.done()
				dispatch(reset('AccountSetupForm'))
				dispatch(Notifications.success({
					title: 'Success',
					message: 'Account created and email invite sent successfully',
					position: 'bl'
				}))
				return response
			})
			.catch((error) => {
				NProgress.done()
				const message = error.response && error.response.data && error.response.data.message
					? error.response.data.message
					: 'An error occurred when creating account setup'
				dispatch(Notifications.error({
					title: 'Error',
					message,
					position: 'bl'
				}))
				throw error
			})
	}
}

export function accountSetupResend(id: number) {
	return (dispatch: Function) => {
		NProgress.start()
		return accountSetupResendApi(id)
			.then(() => {
				NProgress.done()
				dispatch(Notifications.success({
					title: 'Success',
					message: 'Email invite resent successfully',
					position: 'bl'
				}))
			})
			.catch(() => {
				NProgress.done()
				dispatch(Notifications.error({
					title: 'Error',
					message: 'An error occurred when resending email',
					position: 'bl'
				}))
			})
	}
}
